<template>
  <CockpitDialog
    title="AI视频分析报警列表"
    :top="'200px'"
    :left="'500px'"
    :width="'1000px'"
    :height="'500px'"
    @close="close"
  >
    <div class="w-full h-full">
      <div class="flex mb-10px">
        <el-select clearable v-model="searchForm.buildingName" placeholder="所属建筑" class="mr-10px w-200px" popper-class="visualization-select-popper">
          <el-option
            v-for="item in buildingList"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
        <el-select clearable v-model="searchForm.alarmType" placeholder="报警类型" class="mr-10px w-200px" popper-class="visualization-select-popper">
          <el-option
            v-for="item in alarmTypeList"
            :key="item"
            :value="item"
            :label="item"
          ></el-option>
        </el-select>
        <el-date-picker
          class="mr-10px w-220px"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchForm.identifyTime"
          popper-class="visualization-picker-popper"
          clearable
        ></el-date-picker>
        <el-button size="small" type="primary" @click="searchList">搜索</el-button>
        <el-button size="small" type="primary" @click="resetSearch">重置</el-button>
      </div>
      <el-table
        ref="tableRef"
        height="calc(100% - 80px)"
        class="mt-10px"
        :data="detailList"
        highlight-current-row
        v-loading="warningLoading"
      >
        <el-table-column label="序号" type="index" width="50px" show-overflow-tooltip></el-table-column>
        <el-table-column label="设备名称" prop="deviceName" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="设备编号" prop="deviceCode" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="所属建筑" prop="buildingName" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="所属楼层" prop="floor" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="报警类型" prop="alarmTypeName" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="识别图片" prop="identifyPicture" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-image
              class="w-full h-50px"
              :src="scope.row.identifyPicture"
              :preview-src-list="[scope.row.identifyPicture]"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="识别时间" prop="identifyTime" show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <el-pagination
        small
        background
        @size-change="searchList"
        @current-change="findList"
        :current-page.sync="pageInfo.pageNo"
        :page-size.sync="pageInfo.pageSize"
        layout="total, prev, pager, next"
        :total="pageInfo.pageTotal"
        class="text-center"
      ></el-pagination>
    </div>
  </CockpitDialog>
</template>

<script>
import { map, assign } from 'lodash'
import dayjs from 'dayjs'
import { transferSkipCount } from '@/assets/js/TransferPage'
import { BuildingApi } from '@wiz-api/personnel-position'
import { SecurityAlarmRecordApi } from '@wiz-api/security-management'

const CockpitDialog = () => {
  return import('@/components/cockpit/CockpitDialog')
}

const buildingApi = new BuildingApi()
const securityAlarmRecordApi = new SecurityAlarmRecordApi()

export default {
  name: 'WorkAlarmList',
  components: {
    CockpitDialog
  },
  props: {
    isShowDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      handleDialogVisible: false,
      warningLoading: false,
      alarmTypeList: [],
      buildingList: [],
      detailList: [],
      alarmType: '',
      building: '',
      searchTime: [],
      pageInfo: {
        pageTotal: 0,
        pageSize: 15,
        pageNo: 1,
      },
      searchForm: {
        keyWords: '', // 设备名称
        buildingName: '', // 报警建筑
        floor: '', // 报警楼层
        alarmType: '', // 报警类型
        identifyTime: ['', ''],
      }, // 表单搜索
    }
  },
  created() {
    this.getAlarmBuildingList()
    this.getAlarmTypeList()
    this.resetSearch()
  },
  methods: {
    // 获取建筑
    async getAlarmBuildingList() {
      const [err, res] = await buildingApi.getListNoPage()
      if (!err && res ) {
        this.buildingList = res.map(item => {
          return {
            id: item.id,
            name: item.name
          }
        })
      }
    },
    // 获取报警类型
    async getAlarmTypeList() {
      const [err, res] = await securityAlarmRecordApi.getAlarmTypeNames()
      if (!err && res) {
        this.alarmTypeList = res
      }
    },
    // 搜索
    handleSearch() {
      this.pageInfo.pageNo = 1
    },
    // 带条件分页搜索
    searchList() {
      this.pageInfo.pageNo = 1
      this.findList()
    },
    // 重置搜索
    resetSearch() {
      this.searchForm = this.$options.data().searchForm
      this.searchList()
    },
    // 列表搜索
    async findList() {
      this.tableLoading = true
      const [identifyStartTime, identifyEndTime] = this.searchForm.identifyTime || ['', '']
      const [err, res] = await securityAlarmRecordApi.getList({
        ...this.searchForm,
        identifyStartTime,
        identifyEndTime,
        sorting: '',
        skipCount: transferSkipCount(this.pageInfo.pageNo, this.pageInfo.pageSize),
        maxResultCount: this.pageInfo.pageSize,
      })
      this.tableLoading = false
      if (!err) {
        this.detailList = this.getCheckList(res.items)
        this.pageInfo.pageTotal = res.totalCount
      }
    },
    // 初始化表格数据
    getCheckList(res) {
      return map(res, (item) => {
        return assign(item, {
          disposeTime: item.disposeTime
            ? dayjs(item.disposeTime).format('YYYY-MM-DD HH:mm:ss')
            : '',
          identifyTime: item.identifyTime
            ? dayjs(item.identifyTime).format('YYYY-MM-DD HH:mm:ss')
            : '',
        })
      })
    },
    close() {
      this.$emit('update:isShowDialog', false)
    },
    handlingDialogclose() {
      this.handleDialogVisible = false
    },
  }
}
</script>

<style lang="scss" scoped>

</style>